import gql from 'graphql-tag';
import { blogArticleFragment } from '../fragments';
export const getPublishedArticlesQuery = gql `
  query GetPublishedArticles($record: GetPublishedArticlesRecord!) {
    getPublishedArticles(record: $record) {
      ...articleFields
      category {
        id
        slug
        translations {
          id
          name
          language {
            name
            code
          }
        }
      }
      id
      createdAt
      publishDate
      readingTime
      slug
      status
      updatedAt
      thumbnail
      translations {
        headline
        id
        description
        tagWords
        language {
          code
        }
      }
    }
  }
  ${blogArticleFragment}
`;
//# sourceMappingURL=getPublishedArticles.js.map